/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Rotate_Explainer2Inputs */

const en_settings_reportingapikeys_rotate_explainer2 = /** @type {(inputs: Settings_Reportingapikeys_Rotate_Explainer2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotating replaces this API key with a new one under the same name. Use it when a key may have been exposed or lost, or as part of regular key hygiene. Rotate rather than generating a separately named key when the client should keep their existing integration: the key name and everything configured around it stay the same, only the key itself changes. The moment you rotate, the current key stops working and the new key (shown once on the next screen) takes over with the expiry you choose below. There is no overlap window, so coordinate with the client: they must replace the old key with the new one before their integration can call the reporting APIs again.`)
};

/**
* | output |
* | --- |
* | "Rotating replaces this API key with a new one under the same name. Use it when a key may have been exposed or lost, or as part of regular key hygiene. Rotate..." |
*
* @param {Settings_Reportingapikeys_Rotate_Explainer2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_rotate_explainer2 = /** @type {((inputs?: Settings_Reportingapikeys_Rotate_Explainer2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Rotate_Explainer2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_rotate_explainer2(inputs)
});
export { settings_reportingapikeys_rotate_explainer2 as "settings_reportingApiKeys_rotate_explainer" }